/** Formats a value for text fields without Object's default stringification. */
export const stringifyUnknownValue = (value: unknown): string => {
  if (value == null) return '';
  if (
    typeof value === 'string' ||
    typeof value === 'number' ||
    typeof value === 'boolean' ||
    typeof value === 'bigint' ||
    typeof value === 'symbol'
  ) {
    return String(value);
  }
  if (typeof value === 'function') return '[Function]';
  try {
    return JSON.stringify(value) ?? '[Unsupported value]';
  } catch {
    // swallow-ok: Cyclic or otherwise unserializable display values render an explicit Unserializable object marker instead of a fabricated successful serialization.
    return '[Unserializable object]';
  }
};
